module.exports = __webpack_public_path__ + "img/await-store.75fd1af8.png";